var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8845 5.32992L14.8134 4.40096L12.7659 2.35341L11.8369 3.28237L13.8845 5.32992ZM12.7121 6.50223L10.6646 4.45468L3.00504 12.1142L2.53377 14.6331L5.05259 14.1618L12.7121 6.50223ZM16.0352 3.27816C16.6554 3.89827 16.6554 4.90365 16.0352 5.52376L6.04344 15.5156C5.92523 15.6338 5.77405 15.7135 5.60973 15.7442L1.64879 16.4853C1.07602 16.5925 0.574366 16.0908 0.681529 15.518L1.42261 11.5571C1.45335 11.3928 1.53306 11.2416 1.65126 11.1234L11.6431 1.13158C12.2632 0.511478 13.2686 0.511478 13.8887 1.13158L16.0352 3.27816ZM15.6752 16.4998H8.99207C7.89196 16.4998 7.89196 14.8332 8.99207 14.8332H15.6752C16.7754 14.8332 16.7754 16.4998 15.6752 16.4998Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c89b6d5cff01337fad4369e5a9669c1a.svg";
export { ForwardRef as ReactComponent };